import React from "react";

export default function InfoTable() {
  return (
    <div className="py-8 flex justify-center items-center w-full px-[10%]">
      <table className="w-full border-collapse">
        <thead>
          <tr>
            <th colSpan="2" className="py-4 text-center text-2xl font-bold tracking-tight">
              Why Use Crypto Ticketing?
            </th>
          </tr>
          <tr className="text-xs font-semibold uppercase tracking-wider text-white/50">
            <th className="pr-16 py-4 text-left">Feature</th>
            <th className="pl-16 py-4 text-left">Benefit</th>
          </tr>
        </thead>
        <tbody>
          <tr className="border-b border-white/10 font-normal text-base">
            <td className="pr-16 py-3">Peer-to-Peer Transactions</td>
            <td className="px-16 py-3">
              Buy and sell tickets directly without middlemen
            </td>
          </tr>
          <tr className="border-b border-white/10 font-normal text-base">
            <td className="pr-16 py-[13px]">Blockchain-Backed</td>
            <td className="px-16 py-3">
              Secure, transparent, and tamper-proof
            </td>
          </tr>
          <tr className="border-b border-white/10 font-normal text-base">
            <td className="pr-16 py-3">Borderless Access</td>
            <td className="px-16 py-3">
              Attend or invest in Vegas shows from anywhere in the world
            </td>
          </tr>
          <tr className="border-b border-white/10 font-normal text-base">
            <td className="pr-16 py-3">No KYC Required</td>
            <td className="px-16 py-3">
              Non-custodial, privacy-first wallet support
            </td>
          </tr>
          <tr className="border-b border-white/10 font-normal text-base">
            <td className="pr-16 py-3">Invest in the Show</td>
            <td className="px-16 py-3">
              Not just tickets: invest in productions via smart contracts
            </td>
          </tr>
          <tr className="border-b border-white/10 font-normal text-base">
            <td className="pr-16 py-3">Coming Soon: NFT Access</td>
            <td className="px-16 py-3">
              Tickets as digital collectibles with built-in perks
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
